"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var axios = require('axios/dist/axios.js');
var _require = require('bson'),
  ObjectId = _require.ObjectId;
var _ = require('lodash');
var moment = require('moment');
var FINDING_STATUSES = require('../../common/constant/finding-status.constant');
var FINDING_VALUES = require('../../common/constant/finding-value.constant');
module.exports = /*@ngInject*/function ($injector, $http, $resource, ChecklistService, ConfigService, LokiService, PreferenceService, MOBILE, ProfileService) {
  var _ConfigService$getCon = ConfigService.getConfig(),
    INSPECT_URL = _ConfigService$getCon.INSPECT_URL;
  var CameraService = MOBILE ? $injector.get('CameraService') : {};
  var service = $resource("".concat(INSPECT_URL, "/api/report/:id"), {
    id: '@id'
  }, {
    getPublic: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/public/report/:shareableToken")
    },
    sync: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/sync"),
      isArray: 1
    },
    listReports: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/listReports")
    },
    _upload: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/upload")
    },
    _update: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/update")
    },
    _findLatestDraft: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/configuration/:configId/party/:partyId")
    },
    sendReportForDebugging: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/debug")
    },
    deactivateShareableLink: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/deactivateShareableLink")
    },
    generateShareableLink: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/generateShareableLink")
    },
    mergeDraft: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/mergedraft")
    },
    submitForReview: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/submitforreview")
    },
    sendToRP: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/sendtorp")
    },
    resendToRP: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/resendtorp")
    },
    sendPublicReport: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/sendpublic")
    },
    rollback: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/rollback")
    },
    updateResolution: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/finding/resolution")
    },
    getFromServer: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/:id")
    },
    deleteAttachment: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/report/attachment/:name")
    },
    getReportHistory: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/:id/history"),
      isArray: 1
    },
    getIncidentHistory: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/:id/incident/:incidentId/history"),
      isArray: 1
    },
    openfindings: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/open-findings/summary"),
      isArray: 1
    },
    openfindingsDetail: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/open-findings/detail"),
      isArray: 1
    },
    upsertNote: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/:id/note")
    },
    deleteNote: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/report/:id/note/:noteId")
    },
    updateIncident: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/finding/:findingId/incident/:incidentId")
    },
    deleteIncident: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/report/:id/finding/:findingId/incident/:incidentId")
    },
    getDiscussionRecipients: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/:id/finding/:findingId/incident/:incidentId/discussion/receipients"),
      isArray: true
    },
    addDiscussion: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/:id/finding/:findingId/incident/:incidentId/discussion")
    },
    addSeries: {
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/:id/series")
    },
    updateSeries: {
      method: 'PUT',
      url: "".concat(INSPECT_URL, "/api/report/:id/series/:index")
    },
    deleteSeries: {
      method: 'DELETE',
      url: "".concat(INSPECT_URL, "/api/report/:id/series/:index")
    },
    getReportNotification: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/:id/notification/:type")
    },
    getCountByParty: {
      method: 'GET',
      url: "".concat(INSPECT_URL, "/api/report/party/:partyId/count")
    }
  });
  service.ACCEPTED_ATTACHMENT_FORMATS = '.txt, .ppt, .pptx, .csv, .xls, .xlsx, .docx, .doc, .pdf, image/*';
  service._getDateQueryString = function (date, options) {
    var momentDate = moment(date);
    if (options && options.minus) {
      momentDate.subtract(options.minus, 'days');
    }
    return momentDate.toDate();
  };
  service.reportListStatus = ['Draft', 'Pending Uploads', 'Ready For Review', 'Sent To RP', 'Done'];
  service.calculateStatusBasedOnRole = function () {
    if (!ProfileService.isAdmin() && !ProfileService.isInspector() && !ProfileService.hasManagerInspection()) {
      return ['Sent To RP', 'Done'];
    }
    return service.reportListStatus;
  };
  service.reportQuery = {
    offSet: 0,
    status: service.calculateStatusBasedOnRole()
  };
  service.openFindingsQuery = {
    name: '',
    status: FINDING_STATUSES.NOT_RESOLVED,
    beginDate: service._getDateQueryString(new Date(), {
      minus: 30
    }),
    endDate: service._getDateQueryString(new Date())
  };
  service.get = function (options, cb) {
    if (MOBILE) {
      return LokiService.collection('report').then(function (collection) {
        var result = collection.findOne({
          _id: options.id
        });
        return cb ? cb(result) : result;
      });
    }
    return service.getFromServer({
      id: options.id
    }).$promise;
  };
  service.getPendingSyncReports = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var collection;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return LokiService.collection('report');
        case 2:
          collection = _context.sent;
          return _context.abrupt("return", collection.where(function (report) {
            return report.offlineVersion !== report.onlineVersion && !report.$$submitted;
          }));
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  service.addToDeleteList = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(report) {
      var collection, result;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return LokiService.collection('reportsToDelete');
          case 2:
            collection = _context2.sent;
            result = collection.insert({
              _id: report._id
            });
            _context2.next = 6;
            return LokiService.save(true);
          case 6:
            return _context2.abrupt("return", Promise.resolve(result));
          case 7:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  service.removeFromDeleteList = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(report) {
      var collection;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return LokiService.collection('reportsToDelete');
          case 2:
            collection = _context3.sent;
            collection.removeWhere({
              _id: report._id
            });
            LokiService.save(true);
            return _context3.abrupt("return", Promise.resolve({
              ok: 1
            }));
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function (_x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  service.getPendingUploadReports = function (options, cb) {
    return LokiService.collection('report').then(function (collection) {
      return cb ? cb(collection.data) : collection.data;
    });
  };
  service.syncReports = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5() {
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", service.sync({}).$promise.then(/*#__PURE__*/function () {
            var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(serverReports) {
              var collection, mobileReportsIds, syncedReports;
              return _regenerator["default"].wrap(function _callee4$(_context4) {
                while (1) switch (_context4.prev = _context4.next) {
                  case 0:
                    _context4.prev = 0;
                    _context4.next = 3;
                    return LokiService.collection('report');
                  case 3:
                    collection = _context4.sent;
                    mobileReportsIds = collection.data.map(function (_ref6) {
                      var _id = _ref6._id;
                      return _id.toString();
                    });
                    syncedReports = serverReports.filter(function (serverReport) {
                      return !mobileReportsIds.includes(serverReport._id);
                    });
                    _context4.next = 8;
                    return Promise.all([service.syncImages(syncedReports), service.create(syncedReports)]);
                  case 8:
                    return _context4.abrupt("return", Promise.resolve(syncedReports.length));
                  case 11:
                    _context4.prev = 11;
                    _context4.t0 = _context4["catch"](0);
                    return _context4.abrupt("return", Promise.reject(_context4.t0));
                  case 14:
                  case "end":
                    return _context4.stop();
                }
              }, _callee4, null, [[0, 11]]);
            }));
            return function (_x3) {
              return _ref5.apply(this, arguments);
            };
          }()));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  service.syncImages = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(reports) {
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", Promise.all(service.getAttachments(reports).map(/*#__PURE__*/function () {
              var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(attachment) {
                var _yield$service$downlo, signedUrl;
                return _regenerator["default"].wrap(function _callee6$(_context6) {
                  while (1) switch (_context6.prev = _context6.next) {
                    case 0:
                      _context6.next = 2;
                      return service.downloadFile(attachment.s3Name);
                    case 2:
                      _yield$service$downlo = _context6.sent;
                      signedUrl = _yield$service$downlo.signedUrl;
                      return _context6.abrupt("return", CameraService.downloadFileFromUrl(signedUrl, attachment.name));
                    case 5:
                    case "end":
                      return _context6.stop();
                  }
                }, _callee6);
              }));
              return function (_x5) {
                return _ref8.apply(this, arguments);
              };
            }())));
          case 1:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    }));
    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
  service.getAttachments = function (reports) {
    return reports.reduce(function (acc, report) {
      var noteAttachments = report.notes.reduce(function (attachments, note) {
        return attachments.concat(note.attachments);
      }, []);
      var incidentAttachments = report.findings.reduce(function (attachments, finding) {
        return attachments.concat(finding.incidents.reduce(function (att, incident) {
          return att.concat(incident.attachments);
        }, []));
      }, []);
      return [].concat((0, _toConsumableArray2["default"])(acc), (0, _toConsumableArray2["default"])(noteAttachments), (0, _toConsumableArray2["default"])(incidentAttachments));
    }, []);
  };
  service.findLatestDraft = /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(report) {
      var collection, reports;
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            if (!MOBILE) {
              _context8.next = 6;
              break;
            }
            _context8.next = 3;
            return LokiService.collection('report');
          case 3:
            collection = _context8.sent;
            reports = collection.chain().find({
              $and: [{
                'configuration._id': report.configuration._id
              }, {
                'party.id': report.party.id
              }]
            }).simplesort('createdDate', {
              desc: true
            }).data();
            return _context8.abrupt("return", reports ? reports[0] : null);
          case 6:
            return _context8.abrupt("return", service._findLatestDraft({
              configId: report.configuration._id,
              partyId: report.party.id
            }).$promise);
          case 7:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    }));
    return function (_x6) {
      return _ref9.apply(this, arguments);
    };
  }();
  service.create = /*#__PURE__*/function () {
    var _ref10 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(report) {
      var collection, result;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return LokiService.collection('report');
          case 2:
            collection = _context9.sent;
            result = collection.insert(report);
            _context9.next = 6;
            return LokiService.save(true);
          case 6:
            return _context9.abrupt("return", Promise.resolve(result));
          case 7:
          case "end":
            return _context9.stop();
        }
      }, _callee9);
    }));
    return function (_x7) {
      return _ref10.apply(this, arguments);
    };
  }();
  service.update = function (report) {
    var shouldVersion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    if (MOBILE) {
      return LokiService.collection('report').then(function (collection) {
        if (shouldVersion) {
          service._setVersion(report);
        }
        collection.update(report);
        LokiService.save(true, function () {
          return cb ? cb(report) : report;
        });
      });
    }
    return service._update({
      id: report._id
    }, report, cb);
  };
  service.remove = function (report, cb) {
    return LokiService.collection('report').then(function (collection) {
      collection.remove(report);
      LokiService.save(true, function () {
        return cb ? cb({
          ok: 1
        }) : {
          ok: 1
        };
      });
    });
  };
  service.removeUploadedReports = function (cb) {
    return LokiService.collection('report').then(function (collection) {
      collection.removeWhere({
        $$submitted: true
      });
      LokiService.save(true, function () {
        return cb ? cb({
          ok: 1
        }) : {
          ok: 1
        };
      });
    });
  };
  service.initializeReport = function (configuration, checklist, party, user, managerInspection, status) {
    var filters = _.intersection(checklist.filters, party.attributes) || [];
    return {
      _id: LokiService.generateMongoObjectId(),
      active: true,
      configuration: configuration,
      party: party,
      filters: filters,
      categories: service._buildCategories(checklist),
      findings: service._buildFindings(checklist, filters),
      notes: [],
      managerInspection: managerInspection || false,
      createdDate: new Date(),
      sentToRPDate: null,
      doneDate: null,
      createdBy: {
        userId: user.userId,
        firstName: user.firstName,
        lastName: user.lastName
      },
      status: status || null,
      offlineVersion: 0,
      onlineVersion: 0
    };
  };
  service.initializeIncident = function (finding, categoryName, answer, user, id, verificationDefaultValue) {
    var defaultedAtCategory = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    return {
      id: id,
      category: categoryName,
      correctedOnSite: false,
      referenceFinding: finding.id,
      type: null,
      comments: null,
      privateComments: null,
      location: null,
      tags: _.find(finding.categories, {
        name: categoryName
      }).tags,
      routingGroups: _.find(finding.categories, {
        name: categoryName
      }).routingGroups,
      actionPlan: finding.actionPlan,
      value: answer,
      status: service.calculateIncidentStatus(answer),
      attachments: [],
      resolutions: [],
      createdDate: new Date(),
      daysToResolve: finding.daysToResolve,
      requiresVerification: !!verificationDefaultValue,
      createdBy: user ? {
        userId: user.userId,
        firstName: user.firstName,
        lastName: user.lastName
      } : null,
      $$new: true,
      meta: {
        touched: false,
        defaultedAtCategory: defaultedAtCategory
      }
    };
  };
  service.addDefaultAnswerToIncidents = function (filteredCategoryFindings, category, answer, index, report, currentUser) {
    var defaultedAtCategory = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    filteredCategoryFindings.forEach(function (finding) {
      var matchFinding = _.find(report.findings, {
        id: finding.id
      });
      var incident = matchFinding.incidents[index];
      if (incident && incident.meta.touched) return;
      if (!incident) {
        incident = service.initializeIncident(matchFinding, category.name, answer, currentUser, LokiService.generateMongoObjectId(), false, defaultedAtCategory);
        matchFinding.incidents[index] = incident;
      } else if (defaultedAtCategory || !incident.meta.defaultedAtCategory) {
        incident.value = answer;
        incident.status = service.calculateIncidentStatus(answer);
        incident.meta.touched = false;
        incident.meta.defaultedAtCategory = defaultedAtCategory;
      }
    });

    // eslint-disable-next-line no-param-reassign
    report.categories.find(function (reportCategory) {
      return reportCategory.name === category.name;
    }).$$noFindings = false;
  };
  service.initializeFindingCategory = function (categories, categoryName) {
    var category = _.find(categories, {
      name: categoryName
    });
    category.routingGroups = [];
    return category;
  };
  service.calculateIncidentStatus = function (answer) {
    var status = null;
    switch (answer) {
      case FINDING_VALUES.COMPLIANT:
        status = FINDING_STATUSES.COMPLIANT;
        break;
      case FINDING_VALUES.NOT_COMPLIANT:
        status = FINDING_STATUSES.NOT_RESOLVED;
        break;
      case FINDING_VALUES.NA:
        status = FINDING_STATUSES.NA;
        break;
      case FINDING_VALUES.NOT_OBSERVED:
        status = FINDING_STATUSES.NOT_OBSERVED;
        break;
      default:
        status = null;
    }
    return status;
  };
  service.filterFindingsByCategory = function (findings, categoryName) {
    return _.filter(findings, function (finding) {
      return _.some(finding.categories, function (category) {
        return category.name === categoryName;
      });
    });
  };
  service.filterFindingsAndIncidentsByCategory = function (f, categoryName) {
    var findings = service.filterFindingsByCategory(f, categoryName);
    findings.forEach(function (finding) {
      // eslint-disable-next-line no-param-reassign
      finding.incidents = finding.incidents.filter(function (incident) {
        return incident.category === categoryName;
      });
    });
    return findings;
  };
  service._getAllReportAttachments = function (report) {
    var noteAttachments = report.notes.reduce(function (attachments, note) {
      return attachments.concat(note.attachments.filter(function (attachment) {
        return attachment && !attachment.s3Name && CameraService.getPhotoSrc(attachment.name);
      }));
    }, []);
    var incidentAttachments = report.findings.reduce(function (attachments, finding) {
      return attachments.concat(finding.incidents.reduce(
      // eslint-disable-next-line no-shadow
      function (attachments, incident) {
        return attachments.concat(incident.attachments.filter(function (attachment) {
          return attachment && !attachment.s3Name && CameraService.getPhotoSrc(attachment.name);
        }));
      }, []));
    }, []);
    return Promise.resolve(noteAttachments.concat(incidentAttachments));
  };
  service._processAttachments = /*#__PURE__*/function () {
    var _ref11 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(attachments) {
      var chunkSize, chunk, chunkAttachments, results;
      return _regenerator["default"].wrap(function _callee10$(_context10) {
        while (1) switch (_context10.prev = _context10.next) {
          case 0:
            if (attachments.length) {
              _context10.next = 2;
              break;
            }
            return _context10.abrupt("return", Promise.resolve());
          case 2:
            chunkSize = 5;
            chunk = 0;
          case 4:
            if (!(chunk < attachments.length)) {
              _context10.next = 15;
              break;
            }
            _context10.next = 7;
            return Promise.all(attachments.slice(chunk, chunk + chunkSize).map(function (attachment) {
              return CameraService.getImage(attachment.name);
            }));
          case 7:
            chunkAttachments = _context10.sent;
            _context10.next = 10;
            return Promise.all(chunkAttachments.map(function (attachment) {
              return service.uploadFile(attachment);
            }));
          case 10:
            results = _context10.sent;
            results.forEach(function (_ref12) {
              var uploadedFile = _ref12.uploadedFile;
              var attachment = attachments.find(function (att) {
                return att && att.name === uploadedFile.originalname;
              });
              if (attachment) {
                attachment.attachmentId = new ObjectId().toString();
                attachment.type = 'IMAGE';
                attachment.name = uploadedFile.originalname;
                attachment.s3Name = uploadedFile.name;
              }
            });
          case 12:
            chunk += chunkSize;
            _context10.next = 4;
            break;
          case 15:
            return _context10.abrupt("return", Promise.resolve());
          case 16:
          case "end":
            return _context10.stop();
        }
      }, _callee10);
    }));
    return function (_x8) {
      return _ref11.apply(this, arguments);
    };
  }();
  service.upload = function (r, cb) {
    var report = _.cloneDeep(r);
    service._getAllReportAttachments(report).then(service._processAttachments).then(function () {
      LokiService.stripLokiInformation(report);
      ChecklistService.get({
        id: report.configuration.checklist
      }).then(function () {
        service._upload({}, report, function (response) {
          return cb ? cb(null, response, service._mergeBackLokiInfo(report, r)) : response;
        }, function (error) {
          return cb ? cb(error) : error;
        });
      });
    });
  };
  service._mergeBackLokiInfo = function (pReport, originalReport) {
    var processedReport = pReport;
    processedReport.$loki = originalReport.$loki;
    processedReport.meta = originalReport.meta;
    if (originalReport.configuration.$loki && originalReport.configuration.meta) {
      processedReport.configuration.$loki = originalReport.configuration.$loki;
      processedReport.configuration.meta = originalReport.configuration.meta;
    }
    return processedReport;
  };
  service._buildCategories = function (checklist) {
    var builtCategories = [];
    checklist.categories.forEach(function (category) {
      if (service.filterFindingsByCategory(checklist.findings, category.name).length) {
        builtCategories.push({
          name: category.name,
          required: category.required,
          showDefaultOptions: category.showDefaultOptions,
          showNoFindingOption: category.showNoFindingOption,
          types: category.types,
          multipleSeries: category.multipleSeries
        });
      }
    });
    return builtCategories;
  };
  service._buildFindings = function (checklist, filters) {
    var findings = [];
    checklist.findings.forEach(function (finding) {
      if (filters && filters.length) {
        var findingObj = {
          id: finding.id,
          type: finding.type,
          description: finding.description,
          categories: [],
          incidents: [],
          actionPlan: finding.actionPlan
        };
        finding.categories.forEach(function (category) {
          if (_.intersection(category.filters, filters).length > 0) {
            findingObj.categories.push({
              name: category.name,
              tags: category.tags || [],
              routingGroups: category.routingGroups || [],
              types: category.types || []
            });
          }
        });
        if (findingObj.categories.length > 0) {
          findings.push(findingObj);
        }
      } else {
        findings.push({
          id: finding.id,
          type: finding.type,
          description: finding.description,
          categories: service._buildFindingCategories(finding.categories),
          incidents: [],
          actionPlan: finding.actionPlan,
          daysToResolve: finding.daysToResolve || null
        });
      }
    });
    return findings;
  };
  service._buildFindingCategories = function (categories) {
    return categories.map(function (category) {
      return {
        name: category.name,
        tags: category.tags || [],
        routingGroups: category.routingGroups || [],
        types: category.types || []
      };
    });
  };
  service.isCategoryComplete = function (findings, categoryName, multiSeries) {
    return findings.filter(function (finding) {
      return finding.categories.findIndex(function (category) {
        return category.name === categoryName;
      }) > -1;
    }).every(function (finding) {
      return multiSeries ? finding.incidents.filter(function (incident) {
        return incident.category === categoryName;
      }).every(function (incident) {
        return incident.value;
      }) : finding.incidents.some(function (incident) {
        return incident.category === categoryName;
      });
    });
  };
  service.isCategoryStarted = function (findings, categoryName) {
    return findings.some(function (finding) {
      return finding.incidents.some(function (incident) {
        return incident.category === categoryName;
      });
    });
  };
  service.hasIncompleteCategories = function (report) {
    return report.categories.filter(function (category) {
      return service.isCategoryStarted(report.findings, category.name);
    }).some(function (category) {
      return !service.isCategoryComplete(report.findings, category.name, category.multipleSeries);
    });
  };
  service.uploadFile = /*#__PURE__*/function () {
    var _ref13 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11(file) {
      var presignedUrl, s3Response, scanResponse;
      return _regenerator["default"].wrap(function _callee11$(_context11) {
        while (1) switch (_context11.prev = _context11.next) {
          case 0:
            if (!(file.size >= 10000000)) {
              _context11.next = 2;
              break;
            }
            return _context11.abrupt("return", {
              error: 'File exceeds size limit.'
            });
          case 2:
            _context11.prev = 2;
            _context11.next = 5;
            return service._getPresignedUrl(file.name);
          case 5:
            presignedUrl = _context11.sent;
            _context11.next = 8;
            return service._uploadToS3(presignedUrl, file);
          case 8:
            s3Response = _context11.sent;
            _context11.next = 11;
            return service._scan(s3Response.uploaded);
          case 11:
            scanResponse = _context11.sent;
            return _context11.abrupt("return", {
              uploadedFile: presignedUrl.fileMetadata,
              error: scanResponse.error
            });
          case 15:
            _context11.prev = 15;
            _context11.t0 = _context11["catch"](2);
            return _context11.abrupt("return", {
              error: "Unable to upload file ".concat(_context11.t0.message || _context11.t0)
            });
          case 18:
          case "end":
            return _context11.stop();
        }
      }, _callee11, null, [[2, 15]]);
    }));
    return function (_x9) {
      return _ref13.apply(this, arguments);
    };
  }();
  service._getPresignedUrl = function (fileName) {
    return $http({
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/attachment/presigned-urls"),
      data: {
        fileName: fileName
      }
    }).then(function (_ref14) {
      var data = _ref14.data;
      return data;
    });
  };
  service._uploadToS3 = /*#__PURE__*/function () {
    var _ref15 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12(data, file) {
      var s3Data, key;
      return _regenerator["default"].wrap(function _callee12$(_context12) {
        while (1) switch (_context12.prev = _context12.next) {
          case 0:
            // eslint-disable-next-line no-undef
            s3Data = new FormData(); // eslint-disable-next-line no-restricted-syntax
            for (key in data.fields) {
              if (data.fields[key]) {
                s3Data.append(key, data.fields[key]);
              }
            }
            s3Data.append('file', file);
            _context12.next = 5;
            return axios.post(data.url, s3Data, {
              headers: {
                accept: 'application/json'
              }
            });
          case 5:
            return _context12.abrupt("return", {
              uploaded: data.fileMetadata.name
            });
          case 6:
          case "end":
            return _context12.stop();
        }
      }, _callee12);
    }));
    return function (_x10, _x11) {
      return _ref15.apply(this, arguments);
    };
  }();
  service._scan = function (file) {
    return $http({
      method: 'POST',
      url: "".concat(INSPECT_URL, "/api/report/attachment/scan"),
      data: {
        fileName: file
      }
    });
  };
  service._setVersion = function (report) {
    if (!report.offlineVersion) {
      // eslint-disable-next-line no-param-reassign
      report.offlineVersion = 0;
      // eslint-disable-next-line no-param-reassign
      report.onlineVersion = 0;
    }
    // eslint-disable-next-line no-param-reassign
    report.offlineVersion += 1;
  };
  service.downloadFile = function (fileName) {
    return $http.get("".concat(INSPECT_URL, "/api/report/attachment/").concat(fileName, "/download")).then(function (_ref16) {
      var data = _ref16.data;
      return data;
    });
  };
  service.createAttachmentData = function (file, fileAccessUrl, fileType) {
    return {
      id: new ObjectId().toString(),
      type: fileType,
      name: file.originalname,
      s3Name: file.name,
      $$signedUrl: fileAccessUrl
    };
  };
  service.removeUnsavedAttachments = function (unsaved, toSave) {
    var attachmentsToRemove = unsaved.filter(function (attachment) {
      return !toSave.some(function (a) {
        return a.s3Name === attachment.s3Name;
      });
    });
    return attachmentsToRemove.map(function (attachment) {
      return service.deleteAttachment({
        name: attachment.s3Name
      });
    });
  };
  service.getFindingValueOptions = function (findingValueOptions, findingType) {
    return findingValueOptions.filter(function (option) {
      return option.types.some(function (type) {
        return findingType === type;
      });
    });
  };
  service.findingValueOptions = [{
    value: FINDING_VALUES.NOT_COMPLIANT,
    types: ['YES_NO', 'NOT_OBSERVED']
  }, {
    value: FINDING_VALUES.COMPLIANT,
    types: ['YES_NO', 'NOT_OBSERVED']
  }, {
    value: FINDING_VALUES.NA,
    types: ['YES_NO', 'NOT_OBSERVED']
  }, {
    value: FINDING_VALUES.NOT_OBSERVED,
    types: ['NOT_OBSERVED']
  }];
  return service;
};